const searchToggle = ( toggleButton ) => {
  if ( !toggleButton ) {
    return;
  }

  const panel = document.getElementById( toggleButton.getAttribute( 'aria-controls' ) );

  if ( !panel ) {
    return;
  }

  const searchInput = panel.querySelector( 'input[type="search"]' );
  const closeButton = panel.querySelector( '.header__search-close' );

  const open = () => {
    toggleButton.setAttribute( 'aria-expanded', 'true' );
    panel.setAttribute( 'aria-hidden', 'false' );
    panel.classList.add( 'is-open' );
    document.getElementById( 'main-content' )?.classList.add( 'search-open' );
    searchInput?.focus();
  };

  const close = () => {
    toggleButton.setAttribute( 'aria-expanded', 'false' );
    panel.setAttribute( 'aria-hidden', 'true' );
    panel.classList.remove( 'is-open' );
    document.getElementById( 'main-content' )?.classList.remove( 'search-open' );
    toggleButton.focus();
  };

  toggleButton.addEventListener( 'click', () => {
    toggleButton.getAttribute( 'aria-expanded' ) === 'true' ? close() : open();
  } );

  closeButton?.addEventListener( 'click', close );

  document.addEventListener( 'click', ( event ) => {
    if ( panel.classList.contains( 'is-open' ) && !panel.contains( event.target ) && !toggleButton.contains( event.target ) ) {
      close();
    }
  } );

  document.addEventListener( 'keydown', ( event ) => {
    if ( event.key === 'Escape' && panel.classList.contains( 'is-open' ) ) {
      close();
    }
  } );

  panel.addEventListener( 'keydown', ( event ) => {
    if ( event.key !== 'Tab' || !panel.classList.contains( 'is-open' ) ) {
      return;
    }

    const focusable = panel.querySelectorAll( 'input, button, [href], [tabindex]:not([tabindex="-1"])' );

    if ( !focusable.length ) {
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if ( event.shiftKey && document.activeElement === first ) {
      event.preventDefault();
      last.focus();
    } else if ( !event.shiftKey && document.activeElement === last ) {
      event.preventDefault();
      first.focus();
    }
  } );
};

export default searchToggle;
